import { useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'

const ActTypesSelector = ({ actTypes = null, className = '', disabled, empty, multiple = 'default', style = {}, values, onChange }) => {
  const actTypesOptions = useMemo(() => actTypes.map(actType => ({
    value: actType.id,
    entity: actType,
    label: actType.name,
    tooltip: actType.acronym ?? actType.name
  })), [actTypes])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      empty={empty}
      entityOptions={actTypesOptions}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
    />
  )
}

export default ActTypesSelector
